export const dropDownOption = [
  {
    label: 'Select Program',
    value: 'select program',
  },
  {
    label: 'MBA',
    value: 'mba',
  },
  {
    label: 'EMBA',
    value: 'emba',
  },
  {
    label: 'GMBA',
    value: 'gmba',
  },
  {
    label: 'PGPFMB',
    value: 'pgpgmb',
  },
];

export const todayDropDown = [
  {
    label: 'Choose Day',
    value: 'choose day',
  },
  {
    label: 'Monday',
    value: 'monday',
  },
  {
    label: 'Tuesday',
    value: 'tuesdat',
  },
  {
    label: 'Wednesday',
    value: 'wednesday',
  },
  {
    label: 'Thursday',
    value: 'thursday',
  },
  {
    label: 'Friday',
    value: 'friday',
  },
  {
    label: 'Saturday',
    value: 'saturdat',
  },
  {
    label: 'Sunday',
    value: 'sunday',
  },
];

export const modeDropdown = [
  {
    label: 'Mode 1',
    value: 'mode1',
  },
  {
    label: 'Mode 2',
    value: 'mode2',
  },
];

export const termDropdown = [
  {
    label: 'Term 1',
    value: 'term1',
  },
  {
    label: 'Term 2',
    value: 'term2',
  },
];

export const resourceDropdown = [
  {
    label: 'Resource 1',
    value: 'resource1',
  },
  {
    label: 'Resource 2',
    value: 'resource2',
  },
];
export const facultyDropDown = [
  {
    label: 'Complete',
    value: '1',
  },
  {
    label: 'In Progress',
    value: '2',
  },
  {
    label: 'Yet to Complete',
    value: '3',
  },
];

export const selectOptionsSection = [
  {
    label: 'Choose section',
    value: '--Select--',
  },
  {
    label: 'Section 1',
    value: '1',
  },
  {
    label: 'Section 2',
    value: '2',
  },
  {
    label: 'Section 3',
    value: '3',
  },
];
export const selectOptions = [
  {
    label: 'Choose semester',
    value: '--Select--',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
];

export const campusOptions = [
  {
    label: 'Mumbai',
    value: '1',
  },
  {
    label: 'Singapore',
    value: '2',
  },
  {
    label: 'Dubai',
    value: '3',
  },
];

export const classRoomOptions = [
  {
    label: 'classroom1',
    value: '1',
  },
  {
    label: 'classroom2',
    value: '2',
  },
  {
    label: 'classroom3',
    value: '3',
  },
];

export const courseOptions = [
  {
    label: 'MBA',
    value: '1',
  },
  {
    label: 'EMBA',
    value: '2',
  },
  {
    label: 'GMBA',
    value: '3',
  },
  {
    label: 'PGPFMB',
    value: '4',
  },
];

export const universityOptions = [
  {
    label: 'University of Delhi',
    value: '1',
  },
  {
    label: 'Indian Institute of Technology Bombay',
    value: '2',
  },
  {
    label: 'Indian Institute of Technology Kanpur',
    value: '3',
  },
];

export const departmentOptions = [
  {
    label: 'UG',
    value: '1',
  },
  {
    label: 'PG',
    value: '2',
  },
  {
    label: 'Doctoral',
    value: '3',
  },
];

export const monthOptions = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
  {
    label: '10',
    value: '10',
  },
  {
    label: '11',
    value: '11',
  },
  {
    label: '12',
    value: '12',
  },
];

export const courses = [
  {
    label: 'Finance',
    value: '1',
  },
  {
    label: 'Marketing',
    value: '2',
  },
  {
    label: 'Supply Chain',
    value: '3',
  },
  {
    label: 'Business Analytics',
    value: '4',
  },
];
export const intakes = [
  { label: 'JAN', value: 'JAN'},
  { label: 'FEB', value: 'FEB'},
  { label: 'MAR', value: 'MAR'},
  { label: 'APR', value: 'APR'},
  { label: 'MAY', value: 'MAY'},
  { label: 'JUN', value: 'JUN'},
  { label: 'JUL', value: 'JUL'},
  { label: 'AUG', value: 'AUG'},
  { label: 'SEP', value: 'SEP'},
  { label: 'OCT', value: 'OCT'},
  { label: 'NOV', value: 'NOV'},
  { label: 'DEC', value: 'DEC'},
]
export const years = [
  {
    label: '2021',
    value: '2021',
  },
  {
    label: '2022',
    value: '2022',
  },
  {
    label: '2023',
    value: '2023',
  },
  {
    label: '2024',
    value: '2024',
  },
  {
    label: '2025',
    value: '2025',
  },
  {
    label: '2026',
    value: '2026',
  }
];
export const intakeOptions = [
  { label: 'JAN', value: 'JAN'},
  { label: 'FEB', value: 'FEB'},
  { label: 'MAR', value: 'MAR'},
  { label: 'APR', value: 'APR'},
  { label: 'MAY', value: 'MAY'},
  { label: 'JUN', value: 'JUN'},
  { label: 'JUL', value: 'JUL'},
  { label: 'AUG', value: 'AUG'},
  { label: 'SEP', value: 'SEP'},
  { label: 'OCT', value: 'OCT'},
  { label: 'NOV', value: 'NOV'},
  { label: 'DEC', value: 'DEC'},
];
export const yearOptions = [
  { label: '2015', value: '2015'},
  { label: '2016', value: '2016'},
  { label: '2017', value: '2017'},
  { label: '2018', value: '2018'},
  { label: '2019', value: '2019'},
  { label: '2020', value: '2020'},
  { label: '2021', value: '2021'},
  { label: '2022', value: '2022'},
  { label: '2023', value: '2023'},
  { label: '2024', value: '2024'},
  { label: '2025', value: '2025'},
  { label: '2026', value: '2026'},
  { label: '2027', value: '2027'},
  { label: '2028', value: '2028'},
  { label: '2029', value: '2029'},
  { label: '2030', value: '2030'},
  { label: '2031', value: '2031'},
  { label: '2032', value: '2032'},
  { label: '2033', value: '2033'},
  { label: '2034', value: '2034'},
  { label: '2035', value: '2035'},
  { label: '2036', value: '2036'},
  { label: '2037', value: '2037'},
  { label: '2038', value: '2038'},
  { label: '2039', value: '2039'},
  { label: '2040', value: '2040'},
];